import React, { useEffect } from 'react';
import { useStore } from 'effector-react';
import {
    PageContainer,
    PageHeader,
    PageTitle,
} from '../../components/PageLayout';
import {
    ActionsCell,
    IconButton,
    AddButton
} from '../../components/Table';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper
} from '@mui/material';
import CreatePrinterModal from './components/CreatePrinterModal/CreatePrinterModal';
import { Trash } from 'phosphor-react';
import { PrintersStore } from '../../stores/PrintersStore/PrintersStore';
import { fetchPrintersFx, deletePrinterFx } from '../../stores/PrintersStore/PrintersStore.effects';

const Printers: React.FC = () => {
    const { printers, loading } = useStore(PrintersStore);

    useEffect(() => {
        fetchPrintersFx();
    }, []);

    const handleDelete = async (id: string, name: string) => {
        if (window.confirm(`Tem certeza que deseja remover a impressora "${name}"?`)) {
            try {
                await deletePrinterFx(id);
            } catch (e) {
                alert('Falha ao remover impressora');
            }
        }
    };

    return (
        <PageContainer>
            <PageHeader>
                <PageTitle>Impressoras</PageTitle>
                <CreatePrinterModal TriggerComponent={<AddButton>Adicionar impressora</AddButton>} />
            </PageHeader>

            <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 650 }} aria-label="printers table">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>Nome</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>IP</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>Posto</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>Bombas</TableCell>
                            <TableCell sx={{ whiteSpace: 'nowrap' }}>Ações</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loading && (!printers || printers.length === 0) ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center">Carregando...</TableCell>
                            </TableRow>
                        ) : (!printers || printers.length === 0) ? (
                            <TableRow>
                                <TableCell colSpan={5} align="center">Nenhuma impressora encontrada.</TableCell>
                            </TableRow>
                        ) : (
                            (printers || []).map((printer) => (
                                <TableRow key={printer.id} hover>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{printer.name}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{printer.address}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{printer.station?.name || '-'}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        {printer.gasPumps?.length > 0
                                            ? printer.gasPumps.join(', ')
                                            : '-'}
                                    </TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        <ActionsCell>
                                            <IconButton
                                                $danger
                                                title="Deletar"
                                                onClick={() => handleDelete(printer.id, printer.name)}
                                            >
                                                <Trash size={20} />
                                            </IconButton>
                                        </ActionsCell>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </PageContainer>
    );
};

export default Printers;
